VariationsWidget = window.VariationsWidget ?= {}
VariationsWidget.Collections ?= {}
VariationsWidget.Views ?= {}

VariationsWidget.Collections.Option = require './models/option-collection'
VariationsWidget.Views.OptionCollection = require './views/option-collection'
VariationsWidget.Views.Error = require './views/error'
VariationsWidget.Controller = require './variations-widget-controller'

_scrollToBuyButton = ->
  if $('#purchase-cluster .buy.fixed').length or $('.header-row-sticked').length or $('.header-row-sticky').length
    top = $('.main').position().top - 100
    $('body,html').animate scrollTop: top, 500

# This initiates the client-side widget
VariationsWidget.init = ({variations, stickyHeader}, done) ->
  return done() unless variations?
  {@options, @traits, @uuid, @dealOptionUuid, @preSelectTraits, @printSoldOut, @printOptionPrice, @clearTraitsOnCarouselSelection, @isGetaways} = variations
  @collections = VariationsWidget.Collections.Option.create @traits

  BuyButton.eventBus.board 'buy_button_clicked', =>
    return if BuyButton.view.variationsSelected

    @controller.showErrorMessages()

    if stickyHeader
      _scrollToBuyButton()

    BuyButton.view.enableBuyButton()
    {stopTheBus: true}

  $ =>
    @views = VariationsWidget.Views.OptionCollection.create @collections
    @error = new VariationsWidget.Views.Error el: '#variation-error'
    @controller = new VariationsWidget.Controller()

    if @options?[0].hideOriginalPriceAndDiscount
      $('.deal-discount').hide()
      $('.price-and-value .discount-value').html("")

    window.DealEventPipe.on 'carouselUpdate', (data) =>
      @controller.selectTraitsFromPotentialValues data

    done()


module.exports = VariationsWidget



// WEBPACK FOOTER //
// ./modules/variations/frontend/variations-widget.coffee